// src/utils/geoUtils.js

const R = 6378137; // WGS-84 Earth radius in metres
const DEG = Math.PI / 180;

/**
 * Geodesic area of a GeoJSON polygon ring using the spherical excess Shoelace
 * formula (same method as Google Maps / Turf.js).
 * Coordinates are [lng, lat] pairs in decimal degrees.
 * Returns area in hectares.
 */
export const calculateArea = (coordinates) => {
  try {
    if (!coordinates || !Array.isArray(coordinates) || coordinates.length === 0) return 0;

    const ring = coordinates[0];
    if (!ring || ring.length < 3) return 0;

    let total = 0;
    for (let i = 0; i < ring.length - 1; i++) {
      const [lng1, lat1] = ring[i];
      const [lng2, lat2] = ring[i + 1];
      // Accumulate cross product weighted by cos(mean latitude)
      const midLat = ((lat1 + lat2) / 2) * DEG;
      const dLng = (lng2 - lng1) * DEG;
      total += dLng * Math.sin(midLat);
    }

    const areaM2 = Math.abs(total) * R * R;
    const areaHa = areaM2 / 10000;

    return Math.max(0.01, Math.round(areaHa * 100) / 100);
  } catch (error) {
    console.error('Area calculation error:', error);
    return 0;
  }
};

export const getPolygonCenter = (coordinates) => {
  if (!coordinates || coordinates.length === 0) return null;

  const ring = coordinates[0];
  let sumLat = 0;
  let sumLng = 0;

  for (const [lng, lat] of ring) {
    sumLat += lat;
    sumLng += lng;
  }

  return [sumLng / ring.length, sumLat / ring.length];
};

export const formatCoordinates = (lng, lat, decimals = 4) => {
  return `${lat.toFixed(decimals)}°N, ${lng.toFixed(decimals)}°E`;
};
